import startCase from 'lodash/startCase'
import React from 'react'

const renderProductName = (
    cardNetwork,
    isVirtual,
    productName,
    isGiftProgram = false
) => {
    if (productName) {
        return productName
    }
    if (isVirtual) {
        return <>Digital {startCase(cardNetwork)} Card</>
    }

    return (
        <>
            {startCase(cardNetwork)} {isGiftProgram ? 'Gift' : 'Reward'} Card
        </>
    )
}

export default renderProductName
